<template>
  <Toast />
  <div class="fundo">
    <Toolbar class="p-mb-4 return" v-if="showRegistros">
      <template #left
        >Acompanhe seus registros e as informações diariamente.
      </template>
      <template #right>
        <a href="#" to="/">Clique aqui para voltar.</a>
      </template>
    </Toolbar>
    <div class="container" v-if="showLogin" style="margin-top: 250px">
      <div class="p-col-12 p-md-3">
        <div class="p-shadow-4 login">
          <div class="bodyForm">
            <div class="p-d-flex p-ai-center p-jc-center p-fluid p-grid">
              <div class="p-field formulario">
                <div class="p-d-flex p-ai-center p-jc-center p-mb-6">
                  <!--
                  <img
                    src="assets/layout/images/sespa.png"
                    alt="Logo Sespa"
                    class="responsive"
                  />
                  -->
                </div>
                <form @submit.prevent="searchData()">
                  <div class="field">
                    <InputNumber
                      id="mf"
                      mode="decimal"
                      :useGrouping="false"
                      v-model="form.matricula"
                      placeholder="Digite sua Matrícula. (Sem Dígito)"
                      :class="{ 'p-invalid': submitted && !form.matricula }"
                      autofocus
                    />
                    <small class="p-invalid" v-if="submitted && !form.matricula"
                      >Matrícula Funcional é obrigatório.</small
                    >
                  </div>
                  <br />
                  <div class="field">
                    <InputMask
                      id="cpf"
                      v-model.trim="form.cpf"
                      mask="999.999.999-99"
                      placeholder="Digite o CPF."
                      :class="{ 'p-invalid': submitted && !form.cpf }"
                    />
                    <small class="p-invalid" v-if="submitted && !form.cpf"
                      >Cpf é obrigatório.</small
                    >
                  </div>
                  <br />
                  <div class="field">
                    <InputText
                      id="data"
                      type="date"
                      v-model="form.data"
                      :class="{ 'p-invalid': submitted && !form.data }"
                    />
                    <small class="p-invalid" v-if="submitted && !form.data"
                      >Informe o data que deseja realizar a consulta.</small
                    >
                  </div>
                  <br />
                  <div class="p-d-flex p-ai-center p-jc-center">
                    <Button
                      label="CONSULTAR"
                      class="p-button-info p-mb-3"
                      type="submit"
                    ></Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-grid" v-if="showRegistros">
      <div class="p-col-12">
        <div class="card">
          <div class="p-grid crud-demo">
            <div class="p-col-12 p-md-12">
              <DataTable
                ref="dt"
                :value="registros"
                class="p-datatable-sm p-datatable-striped"
                dataKey="0"
              >
                <template #header>
                  <div class="p-fluid p-formgrid p-grid" id="dadosPonto">
                    <div class="p-field p-col-12 p-md-12">
                      <div class="p-fluid p-formgrid p-grid">
                        <div class="p-col-12 p-md-2">
                          <div class="p-d-flex p-ai-center p-jc-center ctisDiv">
                            <img
                              src="assets/layout/images/sespa.png"
                              alt="SESPA"
                              width="230"
                              class="ctis"
                              style="margin-top: 45px"
                            />
                          </div>
                        </div>
                        <div class="p-col-12 p-md-9" v-if="pessoa[0]">
                          <label>Nome: {{ pessoa[0][0] }}.</label><br />
                          <label>Matricula: {{ pessoa[0][1] }}.</label><br />
                          <label v-if="pessoa[0][3]"
                            >Cargo: {{ pessoa[0][3] }}.</label
                          >
                          <label v-else>Cargo: SEM CARGO</label><br />

                          <label v-if="pessoa[0][4]"
                            >Função: {{ pessoa[0][4] }}.</label
                          >
                          <label v-else>Função: SEM FUNÇÃO.</label> <br />
                          <label>Atuação: {{ pessoa[0][5] }}.</label><br />
                          <label>Situação: {{ pessoa[0][2] }}</label
                          ><br />
                          <label>Horario: {{ pessoa[0][6] }}.</label><br />
                          <label
                            >Referente ao dia
                            {{ formatarData(form.data) }}.</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template #empty>
                  <div class="p-text-center">
                    Nenhum resultado encontrado...
                  </div>
                </template>
                <Column field="0" header="Equipamento">
                  <template #body="slotProps">
                    <span class="p-column-title">Equipamento</span>
                    {{ slotProps.data[0] }}
                  </template>
                </Column>
                <Column field="1" header="N° Registro">
                  <template #body="slotProps">
                    <span class="p-column-title">N° Registro</span>
                    {{ slotProps.data[1] }}
                  </template>
                </Column>
                <Column field="3" header="Batida Data/Hora">
                  <template #body="slotProps">
                    <span class="p-column-title">Batida Data/Hora</span>
                    {{ formatarHora(slotProps.data[3]) }}
                  </template>
                </Column>
                <Column field="4" header="Evento">
                  <template #body="slotProps">
                    <span class="p-column-title">Evento</span>
                    <span
                      v-if="slotProps.data[4] === 1"
                      class="product-badge status-Entrada"
                      >Entrada</span
                    >
                    <span
                      v-if="slotProps.data[4] === 2"
                      class="product-badge status-Saída"
                      >Saída</span
                    >
                  </template>
                </Column>
                <Column field="5" header="Importação">
                  <template #body="slotProps">
                    <span class="p-column-title">Importação</span>
                    {{ formatarDataHora(slotProps.data[5]) }}
                  </template>
                </Column>
                <template #footer
                  >Horas Cumpridas : {{ horasTotal }} horas. <br />
                  Sem desconto de intervalo.
                </template>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <Button
        icon="pi pi-print"
        class="p-button-lg p-button-secondary print"
        v-if="showRegistros"
        @click="imprimirFicha"
      />
    </div>
  </div>
</template>

<script>
import Moment from "moment";
import AuthService from "@/service/Auth/AuthService";
import PessoaService from "@/service/Pessoa/PessoaService";
import BatidaService from "@/service/Batida/BatidaService";

export default {
  data() {
    return {
      form: {
        matricula: null,
        cpf: null,
        data: null,
      },
      pessoa: {
        nome: null,
        mf: null,
        situacao: null,
        cargo: null,
        funcao: null,
        atuacao: null,
        horario: null,
      },
      showRegistros: false,
      showLogin: true,
      horasTotal: null,
      registros: null,
      submitted: false,
    };
  },
  authService: null,
  pessoaService: null,
  batidaService: null,
  created() {
    this.authService = new AuthService();
    this.pessoaService = new PessoaService();
    this.batidaService = new BatidaService();
  },
  methods: {
    searchData() {
      this.submitted = true;
      if (!this.form.matricula || !this.form.cpf || !this.form.data) {
        return;
      }
      this.batidaService
        .controleDeAcessoDiario(this.form)
        .then((data) => {
          if (data.length == 0) {
            this.$toast.add({
              severity: "info",
              summary: "Atenção!",
              detail:
                "Não foram encontrados de registros para matricula " +
                this.form.matricula +
                " na data " +
                this.formatarData(this.form.data) +
                ".",
            });
          } else {
            this.registros = data;
            this.horasCumpridas();
            this.dadosUser(this.form.cpf);
            this.showLogin = false;
            this.showRegistros = true;
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: "Matricula e cpf não conferem.",
            });
          } else {
            console.error(error);
          }
        });
    },
    formatarHora(date) {
      if (date) {
        return Moment(date).utc().format("HH:mm:ss");
      }
      return;
    },
    formatarData(date) {
      if (date) {
        return Moment(date).utc().format("DD-MM-YYYY");
      }
      return;
    },
    formatarDataHora(date) {
      if (date) {
        return Moment(date).utc().format("DD-MM-YYYY HH:mm:ss");
      }
      return;
    },
    dadosUser(cpf) {
      this.pessoaService.listarOcorrenciasPorCpf(cpf).then((data) => {
        this.pessoa = data;
      });
    },
    horasCumpridas() {
      let primeiroDia = this.formatarHora(this.registros[0][3]);
      let ultimoDia = this.formatarHora(
        this.registros[this.registros.length - 1][3]
      );
      let ms = Moment(ultimoDia, "HH:mm:ss").diff(
        Moment(primeiroDia, "HH:mm:ss")
      );
      let d = Moment.duration(ms);
      let s = Math.floor(d.asHours()) + Moment.utc(ms).format(":mm:ss");
      this.horasTotal = s;
    },
    imprimirFicha() {
      window.print();
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.login {
  background-color: #fff;
}
.bodyForm {
  padding: 50px;
}
.responsive {
  width: 70%;
}
.p-datatable-sm .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
#dadosPonto {
  font-size: 12.5px;
}
.fundo {
  height: 100vh;
  overflow: hidden;
  margin-left: -5px;
  //background-image: url("../../../public/assets/layout/images/sespa/fundo.png");
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover*/
}
.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-Entrada {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-Saída {
    background: #ffcdd2;
    color: #c63737;
  }
}
@media screen and (max-width: 40em) {
  ::v-deep(.p-datatable) {
    &.p-datatable-sm {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }
      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;
        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }
        &:last-child {
          border-bottom: 1px solid var(--surface-d);
          text-align: left;
        }
        .p-rating {
          display: inline-block;
        }
      }
    }
  }
}
@media print {
  .print {
    display: none;
  }
  .return {
    display: none;
  }
}
</style>